var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.toastMessage
        ? _c("toast", {
            attrs: { message: _vm.toastMessage },
            on: {
              closed: function ($event) {
                _vm.toastMessage = ""
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c("talk-navbar", {
        staticClass: "mb-1",
        attrs: {
          "fav-mode": _vm.favoriteMode,
          locations: _vm.locations,
          streams: _vm.streams,
          languages: _vm.languages,
          filter: _vm.filter,
          "menu-items": _vm.navbarMenuItems,
          "tool-buttons": _vm.navbarToolButtons,
        },
        on: {
          "toggle-location": function ($event) {
            return _vm.applyFilter("location", $event.id)
          },
          "toggle-stream": function ($event) {
            return _vm.applyFilter("streams", $event.id)
          },
          "toggle-language": function ($event) {
            return _vm.applyFilter("language", $event)
          },
          search: function ($event) {
            return _vm.applyFilter("search", $event)
          },
          "delete-search": function ($event) {
            return _vm.applyFilter("search", "")
          },
        },
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "d-flex justify-content-start mb-2 align-items-center" },
        [
          _c("small", { staticClass: "text-muted me-1" }, [
            _vm._v(
              _vm._s(_vm.numFavorites) +
                " Favoriten / " +
                _vm._s(_vm.numEvents) +
                " Treffer"
            ),
          ]),
          _vm._v(" "),
          _c("filter-pills", {
            attrs: { filterValues: _vm.filter.location, values: _vm.locations },
            on: {
              delete: function ($event) {
                return _vm.applyFilter("location", $event)
              },
            },
          }),
          _vm._v(" "),
          _c("filter-pills", {
            attrs: { filterValues: _vm.filter.language },
            on: {
              delete: function ($event) {
                return _vm.applyFilter("language", $event)
              },
            },
          }),
          _vm._v(" "),
          _c("filter-pills", {
            attrs: { filterValues: _vm.filter.streams, values: _vm.streams },
            on: {
              delete: function ($event) {
                return _vm.applyFilter("streams", $event)
              },
            },
          }),
          _vm._v(" "),
          !_vm.favoriteMode && _vm.routeQueryHasFavorites
            ? _c("span", { staticClass: "badge badge-pill bg-warning me-1" }, [
                _vm._v("\n    Favoriten\n    "),
                _c(
                  "a",
                  {
                    staticClass: "text-decoration-none",
                    attrs: { href: "#" },
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.resetFilter()
                      },
                    },
                  },
                  [_c("i", { staticClass: "fas fa-times-circle" })]
                ),
              ])
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "section",
        { staticClass: "c-list-view" },
        [
          _c(
            "nav",
            { staticClass: "nav nav-pills nav-justified mb-3" },
            _vm._l(_vm.eventDays, function (value, index) {
              return _c(
                "a",
                {
                  key: index,
                  staticClass: "nav-link nav-item",
                  class: { active: _vm.filter.day == value },
                  staticStyle: { "font-size": "1.5rem" },
                  attrs: { href: "#" },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.filterDay(value)
                    },
                  },
                },
                [_vm._v("\n      " + _vm._s(_vm.parseDate(value)) + "\n    ")]
              )
            }),
            0
          ),
          _vm._v(" "),
          _vm.events.length > 0
            ? _c(
                "div",
                { staticClass: "event-container" },
                [
                  _vm.timelineActive
                    ? [
                        _c(
                          "div",
                          { staticClass: "mb-5" },
                          [
                            _c("talk-time-table", {
                              attrs: {
                                "event-short-name": _vm.eventShortName,
                                events: _vm.events,
                              },
                              on: {
                                "favorite-changed": function ($event) {
                                  return _vm.getFavorites()
                                },
                                stream: function ($event) {
                                  return _vm.applyFilter("streams", $event.id)
                                },
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    : _vm._l(_vm.events, function (talk) {
                        return _c(
                          "div",
                          { key: talk.id },
                          [
                            _c("talk-detail", {
                              attrs: {
                                talk: talk,
                                "language-display": _vm.languages.length > 0,
                                "list-display": true,
                              },
                              on: {
                                "favorite-changed": function ($event) {
                                  return _vm.onFavoriteChanged($event)
                                },
                                "talk-detail-required": function ($event) {
                                  return _vm.getTalkDetail(talk)
                                },
                                stream: function ($event) {
                                  return _vm.applyFilter("streams", $event.id)
                                },
                              },
                            }),
                            _vm._v(" "),
                            _c("hr", {
                              staticStyle: { "border-color": "lightgrey" },
                            }),
                          ],
                          1
                        )
                      }),
                ],
                2
              )
            : [
                _c("div", { staticClass: "text-center" }, [
                  _vm._v("-- keine Treffer --"),
                ]),
              ],
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }